import React, { Component } from 'react';
import {Grid, Typography, Button, Paper, TextField} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
import { Settings } from '@material-ui/icons';
import DatasheetView from './DatasheetView';
import moment from 'moment';

export default class AssessmentFormPA extends Component {

    constructor(props) {
        super(props);
        
        // Doesn't reset superadmin
        this.initital_state = {  
            pa_score: '',
            error_pa_score: false,
            self_score: '',
            error_self_score: false,
            overall_measure: '',
            comment: "",
            has_comment: false,
            selectedFile: null,
            writing: false,
            partially_complete: false,
            error: false,
            error_message: '',
            primary_button_enabled: false,
            selecting_assessor: false,
            show_assessors: false,
            search_name:'',
            search_number: '',
            search_ready:false,
            searching:false,
            assessors_array: [],
            assessor_name: this.props.employee_name,
            assessor_number: this.props.employee_number
        };

        this.state = {  
            pa_score: '',
            error_pa_score: false,
            self_score: '',
            error_self_score: false,
            overall_measure: '',
            comment: "",
            has_comment: false,
            selectedFile: null,
            writing: false,
            partially_complete: false,
            error: false,
            error_message: '',
            primary_button_enabled: false,
            is_super_admin_override: false,
            selecting_assessor: false,
            show_assessors: false,
            search_name:'',
            search_number: '',
            search_ready:false,
            searching:false,
            assessors_array: [],
            assessor_name: this.props.employee_name,
            assessor_number: this.props.employee_number
        };

        // this.m_categories = {
        //     1 : "Consistently Not Meeting",
        //     2 : "Inconsistently Meeting",
        //     3 : "Consistently Meeting Targets",
        //     4 : "Consistently Meeting - at times exceeding",
        //     5 : "Consistently Exceeding Targets"
        // }

        this.comment_pattern = new RegExp("^[a-zA-Z0-9 `'?,.;!]+$");
        this.percent_pattern = new RegExp("^[1-9][0-9]{0,2}[.]{0,1}[0-9]{0,2}$");
        this.datasheetFieldSpecs = [
            { field: 'select', headerName: ' ', width: 120, headerAlign: 'center', align:'center',
            sortable: false,
            renderCell: (parms) => (
                <Button 
                    onClick={()=>this.updateAssessor(parms)} 
                    color='primary'
                    variant='outlined'
                    disabled={!this.state.search_ready}
                >
                    Select
                    {/* <HowToRegTwoTone/> */}
                </Button>
            )},
            { field: 'name', headerName: 'Employee', width: 180},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'store_code', headerName: 'Store Code', width: 120, sortable:false},
            { field: 'store', headerName: 'Store', width: 160},
            { field: 'region', headerName: 'Region', width: 160},
            { field: 'date_of_entry', headerName: 'DOE', width: 120},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125}
        ]
    }

    componentDidMount = () => {
        //   check whether this is a capture of someone else's assessment by a super_admin
      if ((this.props.assessment.assessment_type_id==="M"&&(this.props.assessment.reports_to_rom!==this.props.rom_code))||(this.props.assessment.requires_nomination&&(this.props.assessment.nominated_assessor_id!==this.props.employee_number))) {
        this.setState({is_super_admin_override:true})
      }
    };
    

    handleFieldChange = (e) => {
        switch (e.target.id) {
            //Self scopre deprecated...
            // case 'self':
            //     if (!e.target.value){
            //         this.setState({self_score:""});
            //     } else if (this.percent_pattern.test(e.target.value)){
            //         this.setState({self_score:e.target.value, partially_complete:true});
            //         if (Number(e.target.value>110)){
            //             this.setState({error_self_score:true})
            //         } else {
            //             this.setState({error_self_score:false})
            //         }
            //     }
            // break;

            case 'pa':
                if (!e.target.value){
                    this.setState({pa_score:""});
                } else if (this.percent_pattern.test(e.target.value)){
                    this.setState({pa_score:e.target.value, partially_complete:true});
                    if (Number(e.target.value)>100){
                        this.setState({error_pa_score:true,overall_measure:''})
                    // } else {
                    //     const kpi = Number(e.target.value)
                    //     let overall = 5;
                    //     if (kpi<110){overall=4}
                    //     if (kpi<100){overall=3}
                    //     if (kpi<90){overall=2}
                    //     if (kpi<80){overall=1}
                    //     this.setState({error_pa_score:false,overall_measure:overall});
                    }
                }
            break;
        
            default:
            break;
        }
    }

    trimDecimal = (e) => {
        // console.log('blur')
        // console.log(e.target.value.substring(e.target.value.length-1));
        if (e.target.value.substring(e.target.value.length-1)==="."){
            if (e.target.id==='pa'){
                this.setState({pa_score:e.target.value.substring(0,e.target.value.length-1)});
            } else if (e.target.id==='self'){
                this.setState({self_score:e.target.value.substring(0,e.target.value.length-1)});
            }
        }
    }

    handleCommentChange = (e) => {
        // console.log('e.target.value :>> ', e.target.value);
        if (!e.target.value){
            this.setState({comment:"", has_comment:false});
        } else if (this.comment_pattern.test(e.target.value)&&(e.target.value.length<=500)){
            if (e.target.value.length>=1){
                this.setState({comment:e.target.value, partially_complete:true,has_comment:true});
            } else {
                this.setState({comment:e.target.value, partially_complete:true,has_comment:false});
            }
        }
    }

    onFileChange = event => {
        // Update the state
        if (event.target.files[0]){
            // console.log('event.target.files[0] :>> ', event.target.files[0]);
            if (event.target.files[0].size>1024000){
                this.setState({selectedFile:null,error:true,error_message:'This file is larger that 1mb. Please select a smaller file for upload.'});  
            } else if (event.target.files[0].name.slice(-4)!=='.pdf'&&event.target.files[0].name.slice(-4)!=='.PDF'){
                this.setState({selectedFile:null,error:true,error_message:'The selected file does not appear to be a Portable Document Format (PDF) file. Please select .pdf file for upload.'});  
            } else {
                this.setState({selectedFile: event.target.files[0],partially_complete:true});
            }
        } else {
            this.setState({selectedFile:null});
        }
    };
   
    resetMe = () => {
        document.getElementById('file-upload-obj').value = '';
        this.setState(this.initital_state);
    }

    changeAssessor = () => {
        if (this.props.super_admin){
            this.setState({selecting_assessor:true})
        }
    }

    updateAssessor = (parms) => {
        // console.log('parms.row :>> ', parms.row);
        if (this.props.super_admin){
            this.setState({selecting_assessor:false,search_name:'',search_ready:false,searching:false,error:false,error_message:'',show_assessors:false, assessor_name: parms.row.name, assessor_number:parms.row.id})
        }
    }

    submitMe = () => {
        this.setState({writing:true});
        const payload = {
            pa_score : this.state.pa_score,
            self_score : this.state.self_score,
            // overall_measure : this.state.overall_measure,
            comment : this.state.comment,
            assessment : this.props.assessment,
            assessor_employee_number : this.state.assessor_number,
            assessor_not_submitter : this.state.assessor_number !== this.props.employee_number ? true : false
        }

        const formData = new FormData();
        formData.append("asFile",this.state.selectedFile,this.state.selectedFile.name);
        formData.append("payload",JSON.stringify(payload));

        Gserv.sendForm('create_pa_assessment',this.props.gwt,formData)
        .then(reply=>{
            if (reply.error){
                console.log('error on return from Gserv (create_pa_assessment) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (create_pa_assessment) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
            } else {
                this.props.resetParentState();             
            }
        });
    }

    runSearch = (e) => {
        e.preventDefault();
        // console.log('e :>> ', e);

        if (!this.state.search_name&&!this.state.search_number){return}

        this.setState({searching:true, search_ready:false});
        Gserv.sendCommand('find_users_for_group_registry',this.props.gwt,{
            search_string: this.state.search_name? this.state.search_name : this.state.search_number,
            search_type: this.state.search_name? 'surname' : 'employee number',
            assessment: this.state.current_record
        })
        .then(reply => {
            // console.log('search reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (find_users_for_group_registry) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (find_users_for_group_registry) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"){
                //not broken, but for some reason couldn't update / add record
                if (reply.statusCode===204){
                    this.setState({error_message:"No employee records found matching the search."});
                } else {
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."})
                }
            } else {
                if (reply.Records){
                    let record_array = reply.Records;
                    let DOE = null;
                    for (var i=0;i<record_array.length;i++){
                        DOE = new moment(record_array[i].date_of_entry).format("YYYY-MM-DD");
                        record_array[i].date_of_entry = DOE;
                    }
                }
                this.setState({assessors_array:reply.Records,show_assessors:true,searching:false,search_ready:true});

            }
        });

    }

    render() {
        const assmt = this.props.assessment;
        return (
            <div>

                {!this.state.writing&&    
                <Paper
                    elevation={3}
                >
                <Grid
                    container
                    direction='column'
                    // justifyContent='center'
                    // alignContent='center'
                    style={{padding:'25px'}}
                >
                    <Typography
                        variant='h5'
                        color='primary'
                        style={{paddingTop:15, textAlign:'left'}}
                    >
                        Proficiency Assessment <b>(PA)</b> Matrix
                    </Typography>
                    <Typography
                        style={{textAlign:'left',marginBottom:'5px'}}
                    >
                        Assessment Record
                    </Typography>

                    <Typography
                        style={{borderWidth:'1px',borderStyle:'solid',padding:'10px'}}
                    >
                        {assmt.assessment_type} assessment for <b>{assmt.assessee_name}</b> [{assmt.assessee_employee_id}] ({assmt.job_title}) for cycle {assmt.cycle_code}
                    </Typography>

                    <br/>
                    
                    <hr style={{width:'100%'}}/>        

                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='space-evenly'
                        style={{width:'1050px'}}
                    >
                        
                        <TextField
                            id={'pa'}
                            type={'text'}
                            fullWidth={false}
                            label={'PA Score'}
                            helperText={"Assessor PA rating (%)"}
                            autoCapitalize='off'
                            autoComplete='off'
                            autoCorrect='off'
                            required={true}
                            onChange={this.handleFieldChange}
                            value={this.state.pa_score}
                            disabled={this.writing}
                            variant='standard'
                            error={this.state.error_pa_score}
                            style={{width:'90px'}}
                            onBlur={this.trimDecimal}
                        />

                        {/* Self score deprecated */}
                        {/* <TextField
                            id={'self'}
                            type={'text'}
                            fullWidth={false}
                            label={'Self Score'}
                            helperText={"Assessee self rating (%)"}
                            autoCapitalize='off'
                            autoComplete='off'
                            autoCorrect='off'
                            required={true}
                            onChange={this.handleFieldChange}
                            value={this.state.self_score}
                            disabled={this.writing}
                            variant='standard'
                            error={this.state.error_self_score}
                            style={{width:'90px'}}
                        /> */}
                        
                        <Grid item>
                        <Grid 
                            container
                            direction='column'
                            alignContent='center'
                            justifyContent='center'
                            style={{height:'100%'}}
                        >
                            <Typography
                                style={{alignSelf:'center'}}
                                color='primary'
                            >
                                {/* PA Rating */}
                            </Typography>
                            <Typography>
                                    {/* <b>{this.state.overall_measure}</b> - {this.m_categories[this.state.overall_measure]} */}
                            </Typography>
                        </Grid>
                        </Grid>

                        <Grid item>
                        <Grid 
                            container
                            direction='column'
                            alignContent='center'
                            justifyContent='center'
                            style={{height:'100%'}}
                        >
                            <input
                                accept="application/pdf"
                                style={{ display: 'none' }}
                                id="file-upload-obj"
                                multiple={false}
                                type="file"
                                onChange={this.onFileChange}
                                disabled={this.state.selectedFile? true : false}
                            />
                            <label htmlFor="file-upload-obj">
                                <Button 
                                    variant="contained"
                                    color='primary'
                                    component="span"
                                    disabled={this.state.selectedFile? true : false}
                                    style={{marginBottom:15}}
                                >
                                    Upload Assessment Record
                                </Button>
                            </label>

                            {this.state.selectedFile&&
                            <Typography>
                                {this.state.selectedFile.name}
                            </Typography>}

                        </Grid>
                        </Grid>

                    </Grid>
                    <hr style={{width:'100%'}}/>        

                    <TextField 
                        id={'comment'}
                        type={'text'}
                        fullWidth={true}
                        label={'Comment'}
                        inputProps={{maxLength:500,minLength:10}}
                        autoCapitalize='off'
                        autoComplete='off'
                        autoCorrect='off'
                        required={true}
                        onChange={this.handleCommentChange}
                        value={this.state.comment}
                        disabled={this.writing}
                        variant='standard'
                    />

                    <Grid 
                        container
                        direction='row'
                        style={{marginTop:'15px'}}
                        // justifyContent='center'
                        alignItems='center'
                        
                    >            
                        <Typography style={{textAlign:'left'}}>
                            Assessor: <b>{this.state.assessor_name}</b> [{this.state.assessor_number}] 
                        </Typography>
                        {this.state.is_super_admin_override&&
                            <Button 
                                variant="contained"
                                color='primary'
                                style={{marginLeft:'10px'}}
                                onClick={this.changeAssessor}
                                disabled={this.state.selecting_assessor}
                            >
                                Change
                        </Button>}
                    </Grid>
                    
                    {/* ** Start - Assessor Selection Panel ** */}
                    {this.state.selecting_assessor&&
                    <div>    
                        <hr/>    
                        <Typography
                            color='primary'
                            style={{paddingTop:10}}
                        >
                            Select Assessor
                        </Typography>
                        <Grid
                            container
                            direction='column'
                            justifyContent='space-evenly'
                            alignContent='center'
                            style={{padding:15}}
                        >
    
                            <form onSubmit={this.runSearch}>
                                <TextField
                                    autoComplete="off"
                                    autoCorrect="off"
                                    autoCapitalize="on"
                                    autoFocus={true}
                                    label={'Surname Search'}
                                    variant='outlined'
                                    value={this.state.search_name}
                                    onChange={(e) => {
                                        const outText = e.target.value.replace(/[^ A-Za-z]+/g, '').toUpperCase();
                                        const can_sub = (outText.length>2);
                                        this.setState({search_name: outText, search_number: '', search_ready: can_sub, error: false});
                                    }}
                                    // required
                                    style={{marginBottom:'10px', marginRight:'10px'}}
                                    disabled={this.state.searching}
                                />
                                <TextField
                                    autoComplete="off"
                                    autoCorrect="off"
                                    autoCapitalize="off"
                                    autoFocus={false}
                                    label={'Employee # Search'}
                                    variant='outlined'
                                    value={this.state.search_number}
                                    onChange={(e) => {
                                        const outText = e.target.value.replace(/[^ A-Za-z0-9]+/g, '').toUpperCase();
                                        const can_sub = (outText.length>2);
                                        this.setState({search_number: outText, search_name:"", search_ready: can_sub, error: false});
                                    }}
                                    // required
                                    style={{marginBottom:'10px', marginLeft:'10px'}}
                                    disabled={this.state.searching}
                                />
                                <br/>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    type='submit'
                                    disabled={!this.state.search_ready}
                                >
                                    Search
                                </Button>
                                <Button
                                    variant='contained'
                                    onClick={()=>this.setState({selecting_assessor:false,search_name:'',search_ready:false,searching:false,error:false,error_message:'',show_assessors:false, assessor_name: this.props.employee_name, assessor_number:this.props.employee_number})}
                                    style={{marginLeft:'10px'}}
                                    // color='primary'
                                    // type='submit'
                                >
                                    I'm the Assessor
                                </Button>
                                <Button
                                    variant='contained'
                                    onClick={()=>this.setState({selecting_assessor:false,search_name:'',search_number:'',search_ready:false,searching:false,error:false,error_message:'',show_assessors:false})}
                                    style={{marginLeft:'10px'}}
                                    // color='primary'
                                    // type='submit'
                                >
                                    Back
                                </Button>
                            </form>
                        </Grid>
                    </div>}
    
                    {this.state.show_assessors&&
                    <DatasheetView
                        dataset={this.state.assessors_array}
                        fieldspecs={this.datasheetFieldSpecs}
                        delete={false}
                        edit={false}
                        handleDelete={null}
                        handleEdit={null}
                        loading={this.state.searching}
                        deleteHeaderName={'Delete'}
                        height={350}
                    />}
                    {/* **End Assessor Selection Panel */}


                    <Grid item>
                        <Typography color='secondary' style={{Width:1200,maxWidth:1200, textAlign:'center'}}>{this.state.error_message}</Typography>
                        {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
                    </Grid>

                    {!this.state.selecting_assessor&&        
                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='center'
                        style={{width:'1050px'}}
                    >
                        <Button 
                            type='button'
                            variant='outlined'
                            disabled={this.state.writing}
                            onClick={this.props.returnToParent}
                            style={{marginTop:'20px',marginBottom:'10px'}}
                        >
                            Cancel
                        </Button>
                        <Button 
                            type='button'
                            variant='outlined'
                            disabled={!this.state.partially_complete}
                            onClick={this.resetMe}
                            style={{marginTop:'20px',marginBottom:'10px'}}
                        >
                            Reset
                        </Button>
                        <Button 
                            color='primary'
                            variant='contained'
                            disabled={!(this.state.pa_score&&this.state.has_comment&&this.state.selectedFile)||this.state.writing}
                            style={{marginTop:'20px',marginBottom:'10px'}}
                            onClick={this.submitMe}
                        >
                            Submit Assessment
                        </Button>
                    </Grid>}
                </Grid>
                </Paper>}

                {this.state.writing&&            
                <div className='pageContainer' style={{minHeight:'70vh'}}>
                    <div>
                        <Settings className='icn-spinner' /> Submitting...
                    </div>
                </div>}

                <br/><br/>
            </div>
        );
    }
    
}